// extracted by mini-css-extract-plugin
export default {"flex":"rT","imgwrap":"sT","image":"tT","textinfo":"uT","producttitle":"vT","bolder":"wT","block":"xT","info":"yT","moredetails":"zT","whitebox":"AT","old_price":"BT","discount":"CT"};
    if(module.hot) {
      // 1714442370999
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  